import { mutation, query } from '@/services/graphql';
import * as operations from './operations';

export default {
  fetchSchoolToken(variables = {}) {
    return mutation(operations.FETCH_SCHOOL_TOKEN, variables, true);
  },
  preLogin(variables = {}) {
    return mutation(operations.PRE_LOGIN, variables, true);
  },
  login(variables = {}) {
    return mutation(operations.LOGIN, variables, true);
  },
  getAccount(variables = {}) {
    return query(operations.GET_ACCOUNT, variables, true);
  },
  signIn(variables = {}) {
    return query(operations.SIGN_IN, variables, false);
  },
  updatedAccount(variables = {}) {
    return mutation(operations.UPDATE_ACCOUNT, variables, true);
  },
  logout(variables = {}) {
    return mutation(operations.LOGOUT, variables, true);
  },
  sendCaptcha(variables = {}) {
    return mutation(operations.SEND_SMS_CODE, variables, false);
  },
  register(variables = {}) {
    return mutation(operations.REGISTER, variables, false);
  },
  forgetPassword(variables = {}) {
    return mutation(operations.FORGET_PASSWORD, variables, true);
  },
};
